import omit from 'lodash/omit.js';

export const from = 2;
export const to = 3;

export function up(schema) {
  return omit(
    {
      ...schema,
      name: schema.output?.name,
      ratio: schema.output?.ratio,
      version: to,
    },
    ['output']
  );
}

export function down(schema) {
  return omit(
    {
      ...schema,
      output: {
        name: schema.name,
        ratio: schema.ratio,
      },
      version: from,
    },
    ['name', 'ratio']
  );
}

export default {
  from,
  to,
  up,
  down,
};
